import {
  ContentWorkflow,
  ListDraftContentsResponse,
} from '@amzn/awscat-pattern-library-service-model';
import { delay } from 'bluebird';
import React from 'react';
import { pgsFilter } from '../../api/ContentUtil';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { WorkflowActions } from '../../model/Enum';
import '../../resources/styles/scss/components/pages/dashboard/Dashboard.css';
import Breadcrumbs from '../common/Breadcrumbs';
import AdminCollectionsTable from './AdminCollectionsTable';
import {
  AdminContentNameCol,
  ApprovalsCol,
  ContentAudienceCol,
  ContentIdCol,
  ContentPriorityCol,
  ContentTypeCol,
  DisapprovalsCol,
  DraftStateCol,
  EngagementsCol,
  IsLockedCol,
  IsTestDataCol,
  LastAPGPublicationDateCol,
  LastAPGPublicationVersionCol,
  LastPublicationDateCol,
  ProgressCol,
  PublicationsCol,
  RankCol,
  TechWriterOwnerCol,
  UpdatedDateCol,
  WorkflowTagsCol,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentWorkflowTable from '../workflow-viewer/ContentWorkflowTable';
import { Tabs } from '@amzn/awsui-components-core';

interface DashboardProps {
  foo?: string;
}
interface DashboardState {
  isLoading: boolean;
  workflows: ContentWorkflow[];
  selectedWorkflows: ContentWorkflow[];
}

class Dashboard extends React.Component<DashboardProps, DashboardState> {
  private patternTableColumns;
  private mplService: IMplServiceClient;
  constructor(props: DashboardProps) {
    super(props);
    this.mplService = MplServiceClientFactory.create();

    this.patternTableColumns = [
      ContentIdCol,
      ContentAudienceCol,
      AdminContentNameCol,
      ContentTypeCol,
      DraftStateCol,
      PublicationsCol,
      TechWriterOwnerCol,
      UpdatedDateCol,
      ApprovalsCol,
      DisapprovalsCol,
      RankCol,
      LastPublicationDateCol,
      LastAPGPublicationDateCol,
      LastAPGPublicationVersionCol,
      IsTestDataCol,
      ProgressCol,
      IsLockedCol,
      EngagementsCol,
      WorkflowTagsCol,
      ContentPriorityCol,
    ];

    this.state = {
      isLoading: true,
      selectedWorkflows: [],
      workflows: [],
    };
  }

  public async componentDidMount() {
    this.setState({ isLoading: true });
    const { workflows } = await this.mplService.getAllWorkflows();
    this.setState({ isLoading: false, workflows: pgsFilter(workflows) });
  }

  public render() {
    const { workflows, isLoading } = this.state;

    const breadcrumbItems = [
      { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
      { text: constants.ADMIN_DASHBOARD, href: '' },
    ];
    const allowedControlActions = [
      WorkflowActions.EDIT_WORKFLOW,
      WorkflowActions.DELETE_WORKFLOW,
      WorkflowActions.APG_DISTRIBUTE,
      WorkflowActions.APG_REVOKE,
      WorkflowActions.EDIT_PEER_REVIEWERS,
      WorkflowActions.EDIT_RESOURCE_ACCESS,
      WorkflowActions.EDIT_RESOURCE_AUDIENCE,
      WorkflowActions.DEMOTE_AUDIENCE,
      WorkflowActions.UNLOCK_WORKFLOW,
      WorkflowActions.UNPUBLISH,
      WorkflowActions.DELETE_PUBLICATION_VERSION,
      WorkflowActions.RESET_DRAFT,
    ];

    const allowedFilterTypes: ('contentType' | 'state' | 'workflowTag')[] = [
      'contentType',
      'state',
      'workflowTag',
    ];

    const contentTable = (
      <ContentWorkflowTable
        tableId={WorkflowTableIdentity.AdminDashboard}
        header={constants.ALL_CONTENTS}
        loading={isLoading}
        workflows={workflows}
        columnDefinitions={this.patternTableColumns}
        onRefreshClick={this.loadData}
        allowedControlActions={allowedControlActions}
        allowedFilterTypes={allowedFilterTypes}
        defaultVisibleColumnIds={['tags']}
      />
    );

    return (
      <div>
        <Breadcrumbs items={breadcrumbItems} />
        <Tabs
          ariaLabel="Dashboard navigation"
          tabs={[
            {
              label: constants.CONTENT_HEADER,
              id: constants.CONTENT_HEADER,
              content: contentTable,
            },
            {
              label: constants.COLLECTION_DROPDOWN_HEADER,
              id: constants.ADMIN_DASHBOARD_COLLECTION_HEADER,
              content: <AdminCollectionsTable />,
            },
          ]}
        />
      </div>
    );
  }

  private loadData = async (condition?: any) => {
    this.setState({
      isLoading: true,
    });

    let allContentsResponse: ListDraftContentsResponse;
    let attempts = 0;
    const backoffTime = 2000;

    // Attemp to refresh data to make sure the new content fulfill the expected condition before re-rendering
    while (attempts < 3) {
      allContentsResponse = await this.mplService.getAllWorkflows();
      if (!condition || !condition(allContentsResponse.workflows)) {
        break;
      }
      attempts++;
      await delay(backoffTime);
    }

    this.setState({
      isLoading: false,
      // @ts-expect-error TS2454 - strict migration
      workflows: pgsFilter(allContentsResponse.workflows),
    });
  };
}

export default Dashboard;
